import Grid from "@material-ui/core/Grid";
import React from "react";
import { StepLink } from "./StepLink";
import { IPaginationProps } from "./types";

export const Pagination: React.FC<IPaginationProps> = ({
  compactMessage,
  compactSteps,
  currentPage,
  totalPages,
  PagesComponent,
  LinkComponent
}) =>
  totalPages > 1 ? (
    <Grid
      container={true}
      spacing={16}
      justify={compactSteps ? "center" : "space-around"}
      alignItems="center"
    >
      <Grid item={true}>
        <StepLink
          enabled={currentPage !== 1}
          LinkComponent={LinkComponent(currentPage - 1)}
          isFirst={true}
        />
      </Grid>
      <Grid item={true}>
        <PagesComponent
          compactMessage={compactMessage}
          currentPage={currentPage}
          totalPages={totalPages}
          LinkComponent={LinkComponent}
        />
      </Grid>
      <Grid item={true}>
        <StepLink
          enabled={currentPage !== totalPages}
          LinkComponent={LinkComponent(currentPage + 1)}
          isFirst={false}
        />
      </Grid>
    </Grid>
  ) : null;
